import { render, staticRenderFns } from "./IconCommentHist.vue?vue&type=template&id=6faf7761&"
import script from "./IconCommentHist.vue?vue&type=script&lang=js&"
export * from "./IconCommentHist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports